module.exports = __webpack_public_path__ + "img/pageinsights.b3797d29.png";